import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import ObjectiveCompetencyPillarServices from "./ObjectiveCompetencyPillar.services";
import { ResponsiveEmbed } from "react-bootstrap";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetObjectiveCompetencyPillar = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY_PILLAR,
      payload: true,
    });
    dispatch({
      type: actions.GET_OBJECTIVE_COMPETENCY_PILLAR,
      payload: {
        objectiveCompetencyPillars: [],
        objectiveCompetencyPillarsLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.OBJECTIVE_COMPETENCY_PILLAR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY_PILLAR,
      payload: false,
    });
  }
};

export const getObjectiveCompetencyPillar = (filters) => async (dispatch) => {
  try {

    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY_PILLAR,
      payload: true,
    });
    const resp = await ObjectiveCompetencyPillarServices.getObjectiveCompetencyPillar(filters);
    dispatch({
      type: actions.GET_OBJECTIVE_COMPETENCY_PILLAR,
      payload: {
        objectiveCompetencyPillars: resp.data.data || [],
        objectiveCompetencyPillarsLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.OBJECTIVE_COMPETENCY_PILLAR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.OBJECTIVE_COMPETENCY_PILLAR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY_PILLAR,
      payload: false,
    });
  }
};

export const getObjectiveCompetencyPillarById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY_PILLAR_BY_ID,
      payload: true,
    });
    const resp = await ObjectiveCompetencyPillarServices.getObjectiveCompetencyPillarById(id);
    dispatch({
      type: actions.GET_OBJECTIVE_COMPETENCY_PILLAR_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.OBJECTIVE_COMPETENCY_PILLAR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.OBJECTIVE_COMPETENCY_PILLAR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY_PILLAR_BY_ID,
      payload: false,
    });
  }
};

export const saveObjectiveCompetencyPillar = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_OBJECTIVE_COMPETENCY_PILLAR,
      payload: true,
    });
    const resp = await ObjectiveCompetencyPillarServices.saveObjectiveCompetencyPillar(data);
    const { objectiveCompetencyPillars, objectiveCompetencyPillarsLength } = getState().objectiveCompetencyPillar;
    const _objectiveCompetencyPillars = [...objectiveCompetencyPillars, resp.data];
    dispatch({
      type: actions.GET_OBJECTIVE_COMPETENCY_PILLAR,
      payload: {
        objectiveCompetencyPillars: _objectiveCompetencyPillars,
        objectiveCompetencyPillarsLength: objectiveCompetencyPillarsLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_OBJECTIVE_COMPETENCY_PILLAR,
      payload: false,
    });
  }
};

export const editObjectiveCompetencyPillar = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_OBJECTIVE_COMPETENCY_PILLAR,
      payload: true,
    });
    const resp = await ObjectiveCompetencyPillarServices.editObjectiveCompetencyPillar(id, data);
    const { objectiveCompetencyPillars, objectiveCompetencyPillarsLength } = getState().objectiveCompetencyPillar;
    objectiveCompetencyPillars[index] = resp.data;
    dispatch({
      type: actions.GET_OBJECTIVE_COMPETENCY_PILLAR,
      payload: {
        objectiveCompetencyPillars: objectiveCompetencyPillars,
        objectiveCompetencyPillarsLength: objectiveCompetencyPillarsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_OBJECTIVE_COMPETENCY_PILLAR,
      payload: false,
    });
  }
};

export const deleteObjectiveCompetencyPillar = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY_PILLAR,
      payload: true,
    });
    await ObjectiveCompetencyPillarServices.deleteObjectiveCompetencyPillar(id);
    const { objectiveCompetencyPillars, objectiveCompetencyPillarsLength } = getState().objectiveCompetencyPillar;
    objectiveCompetencyPillars.splice(index, 1);
    dispatch({
      type: actions.GET_OBJECTIVE_COMPETENCY_PILLAR,
      payload: {
        objectiveCompetencyPillars: objectiveCompetencyPillars,
        objectiveCompetencyPillarsLength: objectiveCompetencyPillarsLength - 1,
      },
    });
    dispatch({
      type: actions.OBJECTIVE_COMPETENCY_PILLAR_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_COMPETENCY_PILLAR,
      payload: false,
    });
  }
};
